(() => {
  const labelSliderDots = (root = document) => {
    root.querySelectorAll('.hdt-slider__dots').forEach((container) => {
      const dots = container.querySelectorAll('button.hdt-slider__dot');

      dots.forEach((dot, index) => {
        if (!dot.hasAttribute('aria-label')) {
          dot.setAttribute(
            'aria-label',
            `Go to slide ${index + 1} of ${dots.length}`
          );
        }

        if (dot.classList.contains('hdt-slider__dot--selected')) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    });
  };

  const observer = new MutationObserver((mutations) => {
    if (
      mutations.some(
        (mutation) =>
          mutation.type === 'childList' ||
          mutation.attributeName === 'class'
      )
    ) {
      labelSliderDots();
    }
  });

  const start = () => {
    labelSliderDots();

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();